// eslint-disable filename-rules/match
require('@webapp/common/lib/sentry').default('public-results');
require('@webapp/common/lib/wdyr');

import { createRoot } from 'react-dom/client';

import '@webapp/common/lib/date';

import 'iframe-resizer/js/iframeResizer.contentWindow.min';

import '@webapp/common/assets/styles/globals.css?CSSModulesDisable';

import { WithGlobalStore } from '@webapp/common/components/with-global-store';
import { installChunkLoadReload } from '@webapp/common/lib/chunk-error';
import { initYaMetrika } from '@webapp/common/lib/metrics';

import { App } from './app';

installChunkLoadReload();
initYaMetrika();

const root = createRoot(document.getElementById('app'));

root.render(<WithGlobalStore element={<App />}/>);
